import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";

const AuthContext = createContext({ user: null, login: async () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
  // null = kontrol ediliyor, false = oturum yok, obje = giriş yapılmış
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.me().then(setUser).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.login({ email, password });
    setUser(r.user);
    return r.user;
  };

  const logout = async () => {
    try { await api.logout(); } catch {}
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function AuthGate() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

export function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center bg-secondary/30 grain">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-foreground text-background">
          <Sparkles className="h-5 w-5 animate-pulse" />
        </div>
      </div>
    );
  }
  if (user === false) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
